const colors = {
  primary: {
    white: '#FFFFFF',
    green: '#01A386'
  },
  maroon: '#A2084D',
  black: {
    500: '#1a202c' // black clore
  },
  teal: {
    100: '#E6F3F3',
    150: '#E9F7F9',
    200: '#00A1B7', // unofficial
    300: '#00879A', // unofficial
    400: '#007787', // unofficial
    500: '#01A386',
    600: '#2F7A7C', // same as customTeal
    700: '#256163',
    800: '#00343C', // unofficial
    900: '#001B1F' // unofficial
  },
  neutral: {
    0: '#FFFFFF',
    50: '#F7F9F9', // light mode bg grey
    100: '#EFF3F3', // light mode divider
    150: '#F1F4F4', // light mode divider
    200: '#E6E8E8', // light mode borders
    300: '#D5D8D8',
    333: '#333333',
    350: '#7D7C7B',
    400: '#AFB4B4', // quarternary light mode text colour
    450: '#C7C6C5',
    500: '#899090', // tertiary light mode text colour
    600: '#636D6D', // secondary light mode text colour
    700: '#272B2B', // primary light mode text colour
    750: '#191919',
    800: '#1E2121',
    900: '#151717' // dark mode bg
  },
  yellow: {
    300: '#F5B840',
    400: '#E1B033',
    500: '#E1B033'
  },
  secondary: {
    alert: '#DF5C64', // red.400
    music: '#6FB36D', // green.400
    live: '#BD3E6F', // pink.400
    sleep: '#594C94', // purple.500
    playlists: '#599ACF', // blue.400
    courses: '#D9A853', // yellow.400
    workshop: '#599ACF', // blue.400
    darkGrey: '#3E3E3E',
    lightGrey: '#C7C6C5'
  },
  workplaceBlue: {
    25: '#CFDBF2',
    100: '#F5F8FC',
    400: '#406FCB',
    500: '#345BA6'
  },
  blue: {
    400: '#599ACF'
  },
  purple: {
    400: '#6F5FB4',
    500: '#594C94'
  },
  pink: {
    400: '#BD3E6F'
  },
  text: {
    darkest: '#222222',
    darkGray: '#181818',
    medium: '#5a5a5a',
    medDarkGray: '#222222',
    lightGray: '#727272'
  },
  blackAlpha: {
    600: '#0000007a'
  },
  green: {
    400: '#6FB36D',
    500: '#62A15F',
    900: '#026A6D' // unofficial
  },
  darkGreen: {
    900: '#0D2225'
  },
  cream: {
    200: '#F8F4EF',
    250: '#F9F8F6',
    300: '#F3EDE6',
    400: '#DAD2CE'
  },
  sky: {
    100: '#7feef1',
    400: '#1C95E0'
  },
  lemonYellow: {
    200: '#D9D9CC'
  },
  modal: {
    light: {
      300: '#F5F5F5',
      500: '#ECECEC'
    }
  },
  error: '#EC4641',
  sleep: {
    primary: '#AB8DD0'
  },
  // Footer only — dark green surface used by the global footer (FooterFlux)
  footerBackground: '#142821',
  // Flux navigation tokens (values from web-funnel-next theme)
  flux: {
    white: '#FFFFFF',
    black: '#191919',
    // Chakra v3 default foreground (gray.800), used by web-funnel-next headings
    fg: '#27272A',
    pureBlack: '#000000',
    // Primary CTA fill in the flux navigation (prototype "ink")
    ink: '#141414',
    darkGrey: '#3E3E3E',
    midGrey: '#7D7C7B',
    lightGrey: '#C7C6C5',
    border: '#E3E1DA',
    green: '#01A386',
    sand: '#F9F8F6',
    inputBg: '#F8F8FA',
    darkGreen: '#017A65',
    sand100: '#EEECE6',
    liveRed: '#D7263D',
    chipBg: '#F5F5F7'
  }
};

export default colors;
